export const CHAIRS = `
query chairs(
  $tenant_id: Int!,
  $skip:  Int,
  $take:  Int,
  $orderBy: ChairOrderInput,
  $filter: ChairFilterInput,
  $searchText: String
){
  chairs(
    tenant_id:$tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText:$searchText
  ){
    __typename
    ...on Chair {
      id
      its
      dts
      contact {
        id
        firstname
        lastname
        email
        user {
          id
          email
          active
        }
      }
      chair_account {
        id
        status
      }
      max_prospect_assignments
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
